<div class="dashboard-content position-relative">

    <!-- Loader overlay -->
    @if(loading){
    <div class="loader-overlay d-flex align-items-center justify-content-center">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
    }

    <!-- KPI strip -->
    <div class="row g-2 mb-2">
        <div class="col-6 col-md-4 col-xl">
            <div class="card kpi-card mb-0">
                <div class="card-body d-flex align-items-center">
                    <div class="kpi-icon bg-primary-subtle text-primary">
                        <i class="mdi mdi-clipboard-text-outline"></i>
                    </div>
                    <div class="ms-2">
                        <p class="text-muted mb-0 small">Total Orders</p>
                        <h5 class="mb-0 fw-bold">{{ stampDashboardData?.stampRequests?.total || 0 }}</h5>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-6 col-md-4 col-xl">
            <div class="card kpi-card mb-0">
                <div class="card-body d-flex align-items-center">
                    <div class="kpi-icon bg-success-subtle text-success">
                        <i class="mdi mdi-currency-inr"></i>
                    </div>
                    <div class="ms-2">
                        <p class="text-muted mb-0 small">Total Value</p>
                        <h5 class="mb-0 fw-bold">₹{{ stampDashboardData?.stampRequests?.totalValue || 0 | number }}</h5>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-6 col-md-4 col-xl">
            <div class="card kpi-card mb-0">
                <div class="card-body d-flex align-items-center">
                    <div class="kpi-icon bg-info-subtle text-info">
                        <i class="mdi mdi-package-variant-closed"></i>
                    </div>
                    <div class="ms-2">
                        <p class="text-muted mb-0 small">Inventory</p>
                        <h5 class="mb-0 fw-bold">{{ stampDashboardData?.inventory?.total || 0 }}</h5>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-6 col-md-6 col-xl">
            <div class="card kpi-card mb-0">
                <div class="card-body d-flex align-items-center">
                    <div class="kpi-icon bg-success-subtle text-success">
                        <i class="mdi mdi-cash-multiple"></i>
                    </div>
                    <div class="ms-2">
                        <p class="text-muted mb-0 small">Total Paid</p>
                        <h5 class="mb-0 fw-bold text-success">₹{{ stampDashboardData?.invoices?.totalPaid || 0 | number }}</h5>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-6 col-md-6 col-xl">
            <div class="card kpi-card mb-0">
                <div class="card-body d-flex align-items-center">
                    <div class="kpi-icon bg-warning-subtle text-warning">
                        <i class="mdi mdi-progress-clock"></i>
                    </div>
                    <div class="ms-2">
                        <p class="text-muted mb-0 small">Total Pending</p>
                        <h5 class="mb-0 fw-bold text-warning">₹{{ stampDashboardData?.invoices?.totalPending || 0 | number }}</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Status cards row -->
    <div class="row g-2 mb-2">
        <!-- Stamp requests by status -->
        <div class="col-xl-3 col-md-6">
            <div class="card h-100 mb-0">
                <div class="card-body">
                    <h6 class="card-title fw-bold mb-3">Stamp Requests by Status</h6>
                    <table class="table table-sm status-table mb-0">
                        <tbody>
                            @for(status of stampStatusList; track status.key){
                            <tr>
                                <td><i class="mdi {{ status.icon }} me-2"></i>{{ status.label }}</td>
                                <td class="text-end">
                                    <span class="badge font-size-12" [ngClass]="status.badgeClass">
                                        {{ stampDashboardData?.stampRequests?.byStatus?.[status.key] || 0 }}
                                    </span>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- Inventory by status -->
        <div class="col-xl-3 col-md-6">
            <div class="card h-100 mb-0">
                <div class="card-body">
                    <h6 class="card-title fw-bold mb-3">Inventory by Status</h6>
                    <table class="table table-sm status-table mb-0">
                        <tbody>
                            @for(status of inventoryStatusList; track status.key){
                            <tr>
                                <td><i class="mdi {{ status.icon }} me-2"></i>{{ status.label }}</td>
                                <td class="text-end">
                                    <span class="badge font-size-12" [ngClass]="status.badgeClass">
                                        {{ stampDashboardData?.inventory?.byStatus?.[status.key] || 0 }}
                                    </span>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- Invoices by status -->
        <div class="col-xl-3 col-md-6">
            <div class="card h-100 mb-0">
                <div class="card-body">
                    <h6 class="card-title fw-bold mb-3">Invoices by Status</h6>
                    <table class="table table-sm status-table mb-0">
                        <tbody>
                            @for(status of invoiceStatusList; track status.key){
                            <tr>
                                <td><i class="mdi {{ status.icon }} me-2"></i>{{ status.label }}</td>
                                <td class="text-end">
                                    <span class="badge font-size-12" [ngClass]="status.badgeClass">
                                        {{ stampDashboardData?.invoices?.byStatus?.[status.key] || 0 }}
                                    </span>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- Makers -->
        <div class="col-xl-3 col-md-6">
            <div class="card h-100 mb-0">
                <div class="card-body">
                    <h6 class="card-title fw-bold mb-3">Makers</h6>
                    <table class="table table-sm status-table mb-0">
                        <tbody>
                            <tr>
                                <td><i class="mdi mdi-account-hard-hat text-success me-2"></i>Active Makers</td>
                                <td class="text-end">
                                    <span class="badge font-size-12 bg-success-subtle text-success">
                                        {{ stampDashboardData?.users?.activeMakers || 0 }}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td><i class="mdi mdi-account-clock-outline text-warning me-2"></i>Pending Approval</td>
                                <td class="text-end">
                                    <span class="badge font-size-12 bg-warning-subtle text-warning">
                                        {{ stampDashboardData?.users?.pendingApproval || 0 }}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td><i class="mdi mdi-account-cancel-outline text-danger me-2"></i>Rejected Makers</td>
                                <td class="text-end">
                                    <span class="badge font-size-12 bg-danger-subtle text-danger">
                                        {{ stampDashboardData?.users?.rejectedMakers || 0 }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <!-- Recent stamp requests -->
    <div class="row g-2">
        <div class="col-lg-12">
            <div class="card mb-0">
                <div class="card-body">
                    <h6 class="card-title fw-bold mb-3">Recent Stamp Requests</h6>

                    @if(!loading && stampDashboardData?.recentStampRequests?.length){
                    <div class="table-responsive recent-table-wrap">
                        <table class="table table-sm table-centered mb-0">
                            <thead class="table-light">
                                <tr>
                                    <th>Order Id</th>
                                    <th>Client</th>
                                    <th>Items</th>
                                    <th>Total Value</th>
                                    <th>Status</th>
                                    <th>Created</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for(item of stampDashboardData.recentStampRequests; track item._id){
                                <tr>
                                    <td class="fw-bold">{{ item.bsrId }}</td>
                                    <td>
                                        <span class="d-block">{{ item.clientName }}</span>
                                        <small class="text-muted">{{ item.clientEmail }}</small>
                                    </td>
                                    <td>{{ item.itemCount || 0 }}</td>
                                    <td>₹{{ item.totalValue | number }}</td>
                                    <td>
                                        <span class="badge font-size-12" [ngClass]="statusBadgeClass(item.status)">
                                            {{ statusLabel(item.status) }}
                                        </span>
                                    </td>
                                    <td>{{ item.createdAt | date:'dd/MM/yyyy hh:mm a' }}</td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    }

                    @if(!loading && !stampDashboardData?.recentStampRequests?.length){
                    <div class="text-center py-4 text-muted">
                        <i class="mdi mdi-database-off-outline me-2"></i>
                        No stamp requests available.
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>

</div>
